import { useQuery } from '@tanstack/react-query';
import type { MyGrantDto } from '@aiai/shared';
import { fetchMyGrants } from '../api';
import { qk } from '../api/queryKeys';
import { useOrg } from '../org/useOrg';

/**
 * The caller's own per-project grants in the active workspace — the
 * per-project layer `useCapabilities` resolves resource-aware checks against.
 * Keyed by active org id so switching workspaces refetches; empty until an
 * org is resolved.
 */
export function useMyGrants(): MyGrantDto[] {
  const { activeOrg } = useOrg();
  const { data } = useQuery({
    queryKey: qk.myGrants(activeOrg?.id),
    queryFn: () => fetchMyGrants(),
    enabled: !!activeOrg,
  });
  return data ?? [];
}
